import { Typography } from 'antd'
import { CIMSPage } from '@cims-online/shared'
import ProjectLink from 'components/ProjectLink'
import { GroupFallbackProps } from './types'
import { errorHandler } from 'hooks/errorHandler'

/**
 * @see {@link GroupFallbackProps}
 */
function GroupFallback({ group }: GroupFallbackProps) {
  let page
  if (group === 'Concurrence Levels') page = CIMSPage.FDCConcurrences
  else if (group === 'Approval Groups') page = CIMSPage.FDCApprovalGroups
  else if (group === 'Concurrence Groups') page = CIMSPage.FDCConcurrences
  else if (!page) {
    errorHandler(`Invalid page for group: ${group}`)
    return null
  }
  return (
    <Typography.Paragraph>
      No <ProjectLink item={page}>{group}</ProjectLink> have been configured for
      this Project
    </Typography.Paragraph>
  )
}

export default GroupFallback
